import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import Icon, { ExclamationOutlined } from '@ant-design/icons';

import { disposeNotification, INotification } from '../../../slices/notifications';
import { RootState } from '../../../slices/rootReducer';
import style, { defaultColors } from './notificationsStyles';
import { ReactComponent as CheckIconSVG } from '../../../assets/sightx-icons/svg/icon-check.svg';
import { ReactComponent as FlagIconSVG } from '../../../assets/sightx-icons/svg/icon-flag.svg';
import { ReactComponent as CrossIconSVG } from '../../../assets/sightx-icons/svg/icon-cross.svg';
import './notifications.scss';
import { capitalizeFirstLetter } from '../utils/string';

interface INotificationsProps {
  disposeNotification: () => void;
  newNotification: INotification | null;
}

const AUTO_DISMISS_TIME_IN_SECONDS = 3;
const DEFAULT_NOTIFICATION_POSITION = 'tc';

class Notifications extends Component<INotificationsProps> {
  private notificationRef: React.RefObject<NotificationSystem.System>;

  constructor(props: INotificationsProps) {
    super(props);
    this.notificationRef = React.createRef<NotificationSystem.System>();
  }

  private renderIcon(level?: string) {
    switch (level) {
    case 'success':
      return (
        <div className="iconContainer" style={{ backgroundColor:defaultColors.success.iconShadow }}>
          <Icon component={CheckIconSVG} style={{ backgroundColor: defaultColors.success.hex }} />
        </div>
      );
    case 'warning':
      return (
        <div className="iconContainer" style={{ backgroundColor: defaultColors.warning.iconShadow }}>
          <ExclamationOutlined style={{ backgroundColor: defaultColors.warning.hex }} />
        </div>
      );
    case 'info':
      return (
        <div className="iconContainer" style={{ backgroundColor: defaultColors.info.iconShadow }}>
          <Icon component={FlagIconSVG} style={{ backgroundColor: defaultColors.info.hex }} />
        </div>
      );
    case 'error':
      return (
        <div className="iconContainer" style={{ backgroundColor: defaultColors.error.iconShadow }}>
          <Icon component={CrossIconSVG} style={{ backgroundColor: defaultColors.error.hex }} />
        </div>
      );
    default:
      return null;
    }
  }

  private renderMessage(msg = '') {
    const contactEmail = 'sales@sightx.io';
    const index = msg.indexOf(contactEmail);
    if(index === -1) {
      return msg;
    }
    return (
      <>
        {msg.substring(0, index)} <b className='email'>{contactEmail}</b> {msg.substring(index + contactEmail.length)}
      </>
    );
  }

  private getMessageWithIcon(msg?: string, level?: string) {
    return (
      <div>
        {this.renderIcon(level)}
        <div className="messageContainer">
          <span className="level">{capitalizeFirstLetter(level as string)}</span> {this.renderMessage(msg)}
        </div>
        <div className="dissmissButton">
          <Icon component={CrossIconSVG} />
        </div>
      </div>
    );
  }

  componentDidUpdate() {
    if (this.props.newNotification) {
      const { message, level } = this.props.newNotification;
      const newMessage = this.getMessageWithIcon(message, level);
      this.notificationRef.current?.addNotification({
        message: newMessage,
        position: DEFAULT_NOTIFICATION_POSITION,
        level,
        autoDismiss: AUTO_DISMISS_TIME_IN_SECONDS
      });
      this.props.disposeNotification();
    }
  }

  render() {
    return <NotificationSystem ref={this.notificationRef} style={style} />;
  }
}

const mapStateToProps = (state: RootState) => ({
  newNotification: state.notifications.newNotification
});

export default connect(mapStateToProps, {
  disposeNotification
})(Notifications);
